import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ConstantsModule } from 'src/app/main/shared/constants/constants.module';
import { UtilsSharedModule } from 'src/app/main/shared/utils/utils/utils.module';
import { DatepickerComponent } from 'src/app/utils/datepicker/datepicker.component';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { RainfallActualDataService } from '../../rainfall-actual/rainfall-actual-data.service';

@Component({
  selector: 'app-rainfall-actual-qc-sidebar',
  templateUrl: './rainfall-actual-qc-sidebar.component.html',
  styleUrls: ['./rainfall-actual-qc-sidebar.component.scss']
})
export class RainfallActualQcSidebarComponent implements OnInit {

  selected: string;
  validation: boolean[] = new Array(5).fill(true);
  selectedLocation: any = 'India##00cb31c7-2928-4e6d-adcc-443d478c90d6';
  locationList: any = [];
  latitude: any = {};
  longitude: any = {};
  queryParams: any;
  sourcelist: any = ['MERGED_STATIONS']
  selectedSource: any = 'IMD_STATIONS'
  format: object = { required: true };
  aggr: object = { required: true };
  defaultFormat: any;
  sDate: object = { required: true };
  eDate: object = { required: true };
  minDate: Date;
  maxDate: any;
  @ViewChild(DatepickerComponent, {
    static: false
  }) datepicker: DatepickerComponent;
  isInitialLoad: boolean = false;
  countryUUID = '00cb31c7-2928-4e6d-adcc-443d478c90d6'
  cType: any = 'STATE';
  pType: any = 'COUNTRY';
  ytd: object = { required: true };
  locType: any;
  selectedFilterParams: any = {
    COUNTRY: 'India##00cb31c7-2928-4e6d-adcc-443d478c90d6',
    STATE: '',
    DISTRICT: '',
  }
  hie = ['COUNTRY','STATE','DISTRICT']
  selectedLocForParams: any
  constants: any
  isLocationSelected: boolean = false;
  customOption: boolean = false;

  constructor(private router: Router, private rfActualDataSrv: RainfallActualDataService, private route: ActivatedRoute, public utilsShared: UtilsSharedModule,
    public constantsModule: ConstantsModule, private utils: UtilsService,
  ) {
    this.selected = this.router.url.split("/")[2]
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.isInitialLoad = true
        this.requestSelectedFilterParams()
        this.setAllOtherParameters(this.queryParams)
      }
    });
  }

  setLocation() {
    let currentLoc = this.queryParams.locType
    if (currentLoc == 'COUNTRY') {
      this.selectedLocation = this.queryParams.location
      this.selectedLocForParams = this.selectedLocation
      this.selectedFilterParams[currentLoc] = this.selectedLocation
    } else {
      let location = this.queryParams.location.split('&')
      if (currentLoc == 'STATE') {
        this.selectedLocForParams = location[location.length - 1]
        this.selectedLocation = this.selectedLocForParams
        this.selectedFilterParams[currentLoc] = location[location.length - 1]
      } else {
        let prevLoc = this.hie[this.hie.indexOf(currentLoc) - 1]
        this.selectedLocForParams = location[location.length - 1]
        this.selectedLocation = location[location.length - 2]
        this.selectedFilterParams[prevLoc] = location[location.length - 2]
        this.selectedFilterParams[currentLoc] = location[location.length - 1]
      }
    }
  }

  async setAllOtherParameters(options) {
    let range;
    if (this.locationList.length == 0) {
      this.getLocationList()
    }
    this.pType = this.queryParams.locType
    this.selectedSource = this.queryParams.source
    this.setTimestepList()
    this.setLocation()
    this.onLocationChange(false)
    this.setMinMax(range);
    // this.setYTD(range);
    this.setFormat(options['format']);
    if (this.format['value'] != 'HOURLY') {
      this.setStartDate(this.utilsShared.getDateObjectFromModelDate(options['sDate']));
      this.setEndDate(this.utilsShared.getDateObjectFromModelDate(options['eDate']));
    }
    this.setAggregation(options['aggr']);
  }

  setTimestepList() {
    if (this.selectedSource == 'IMD_STATIONS' || this.selectedSource == 'NHP' || this.selectedSource == 'CWC' || this.selectedSource == 'CMWSSB_STATIONS') {
      this.constants = this.constantsModule.DATEPICKER_DATE
    } else {
      this.constants = this.constantsModule.DATEPICKER_DATES
    }
  }

  setMinMax(range: object): void {
    if (!range || !range['MAX'] || range['MAX'] == 0 || !range['MIN'] || range['MIN'] == 0) {
      let today = new Date();
      let Yesterday = new Date(today.getFullYear() - 1, 10, 12);
      this.minDate = new Date(Yesterday);
      this.maxDate = new Date();
      return;
    }
    this.minDate = this.utilsShared.getDateObjectFromModelDate(range['MIN'].toString());
    this.maxDate = this.utilsShared.getDateObjectFromModelDate(range['MAX'].toString());
    this.maxDate = (this.maxDate.getTime() > (new Date()).getTime()) ? new Date() : this.maxDate;

  }

  setYTD(data: object): void {
    if (!data || !data['MAX'] || data['MAX'] == 0) { return; }
    this.ytd['value'] = data['MAX'].toString().substr(0, 4);
    Object.assign(this.ytd, data);
  }

  setFormat(format: string): void {
    this.format['value'] = this.getFormat(format) || this.defaultFormat;
    if (this.format['value'] != 'HOURLY') {
      if (this.sDate['value']) {
        delete this.sDate['value'];
      }
      if (this.eDate['value']) {
        delete this.eDate['value'];
      }
    } else {
      let today = new Date();
      // let Yesterday = new Date(today.getFullYear(), 10, 12);
      let Yesterday = new Date(today);
      Yesterday.setDate(today.getDate() - 1)
      this.sDate['value'] = this.utilsShared.getTimestampsForSDateEDate(today, 'sDate')
      this.eDate['value'] = this.utilsShared.getTimestampsForSDateEDate(today, 'eDate')
    }
    for (let i = 0; i < this.validation.length; i++) {
      this.validation[i] = true;
    }
  }

  getFormat(format) {
    if (format == 'DAILY') {
      return 'yyyyMMdd';
    } else if (format == 'MONTHLY') {
      return 'yyyyMM';
    } else if (format == 'YEARLY') {
      return 'yyyy';
    } else {
      return format;
    }
  }

  setStartDate(date: Date): void {
    this.sDate['value'] = date;  //this.utils.getDateObjectFromModelDate(this.ytd['value']);
  }

  setEndDate(date: Date): void {
    this.eDate['value'] = date; //this.utils.getDateObjectFromModelDate(this.ytd['value']);
  }

  setAggregation(aggr: string): void {
    this.aggr['value'] = aggr ? aggr : this.constants.AGGR_TYPES.SUM;
  }

  onLocationChange(flag) {
    let stateUUID = this.selectedLocation.split('##')[1]
    this.selectedLocForParams = this.selectedLocation
    this.isLocationSelected = flag
    if (this.countryUUID != stateUUID) {
      // this.rfActualDataSrv.fetchSource(this.countryUUID, stateUUID).subscribe(srcList => {
        this.sourcelist = ['MERGED_STATIONS']
        this.pType = 'STATE';
        this.cType = 'DISTRICT';
        // this.selectedSource = 'IMD_STATIONS';
        this.selectedFilterParams[this.pType] = this.selectedLocation
      // })
    } else {
      this.sourcelist = ['MERGED_STATIONS']
      this.pType = 'COUNTRY';
      this.cType = 'STATE';
      //this.selectedSource = 'IMD_STATIONS';
      this.selectedFilterParams[this.pType] = this.selectedLocation
    }
  }

  async setSource(source: string, reload: boolean = true) {
    this.selectedSource = source
    this.setTimestepList()
  }

  requestHeatMap(): void {
    let today = new Date();
    let Yesterday = new Date(today);
    Yesterday.setDate(today.getDate() - 1)
    let options = { ...this.queryParams }
    options['source'] = this.selectedSource;
    options['location'] = this.getCurrentLocation()
    options['locName'] = this.selectedLocForParams.split('##')[0]
    options['pUUID'] = this.selectedLocForParams.split('##')[1]
    options['locType'] = this.pType
    options['sDate'] = this.format['value'] != 'HOURLY' ? this.utilsShared.getModelDateWithDateFormat(this.sDate['value'], this.format['value']) : this.sDate['value'] = this.utilsShared.getTimestampsForSDateEDate(today, 'sDate')
    options['eDate'] = this.format['value'] != 'HOURLY' ? this.utilsShared.getModelDateWithDateFormat(this.eDate['value'], this.format['value']) : this.eDate['value'] = this.utilsShared.getTimestampsForSDateEDate(today, 'eDate')
    options['format'] = this.format['value']
    options['aggr'] = this.aggr['value']
    options['filter'] = this.isLocationSelected
    console.log(options,"options123");
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

  getCurrentLocation() {
    let locType = this.pType
    let location = '';
    let index = this.hie.indexOf(locType)
    for (var i = 0; i <= index; i++) {
      location += this.selectedFilterParams[this.hie[i]]
      if (this.hie[i] !== this.pType && i < index) {
        location += '&';
      } else if (this.hie[i] === this.pType) {
        break; // Exit the loop when 'this.pType' is encountered
      }
    }
    return location
  }

  getLocationList() {
    let postData = {
      "sDate": "20241009",
      "eDate": "20241009",
      "pUUID": this.queryParams['pEUUID'],
      "pType": 'COUNTRY',
      "format": "DAILY",
      "cType": 'STATE',
      "pEUUID": this.queryParams['pEUUID'],
      "classification": [
        "ACTUAL"
      ],
      "src": "NHP",
      "aggr": "SUM",
      "includeAllLoc": true
    }

    this.rfActualDataSrv.getLocationList(postData).subscribe(response => {
      // this.locationList = response
      if (Object.keys(response).length > 0) {
        const result = [];
        response.forEach((item) => {
          if (item.md && item.md.ln && item.nm != 'TOTAL') {
            item.nm = this.utils.titleCase(item.nm)
            this.locationList.push(item)
            this.latitude[item.uid] = item.md.lt;
            this.longitude[item.uid] = item.md.lng;
          }
        });
        this.locationList.sort((a, b) => a.nm.localeCompare(b.nm));  //sorting states names in alphabetical order
      }
    })
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'RAINFALLACTUALQC';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.utils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

}
